// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { styles } from "@bg/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { ProductSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.selectSortOption = {
    cssOverrides: {
        formField: css`
            flex-direction: row;
            align-items: center;
            width: 228px;

            label {
                width: auto;
                font-weight: ${fontConfig.weight.bold};
                font-size: ${fontConfig.fontSize.small}px;
                margin-right: 8px;
                white-space: nowrap;
            }
            @media (max-width: 650px) {
                width: 100%;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
        inputSelect: css`
            font-size: ${fontConfig.fontSize.small}px;
            height: 32px;
            font-weight: ${fontConfig.weight.semiBold};
        `,
    },
};

styles.addItemsLink = {
    css: css`
        margin-right: 30px;
        &&:hover svg path,
        &&:focus svg path {
            fill: ${getColor("tertiary")} !important;
            d: path(
                "M 14.65 0 C 12.72 0 11.02 0.87 10 2.19 C 8.98 0.87 7.28 0 5.35 0 C 2 0 0 2.87 0 5.65 c 0 6.31 9.11 11.67 9.5 11.9 l 0.5 0.29 l 0.5 -0.29 c 0.39 -0.23 9.5 -5.59 9.5 -11.9 C 20 2.48 17.65 0 14.65 0 Z M 10 5.06 L 10 5.06 L 10 5.06 L 10 5.06 Z"
            ) !important;
        }
    `,
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.regular}px;
            line-height: ${fontConfig.lineHeight.small};
            font-weight: ${fontConfig.weight.semiBold};
            opacity: 0.8;
            &&:hover,
            &&:focus {
                text-decoration: underline;
            }
        `,
    },
    icon: {
        iconProps: {
            src: "ProductListStroked",
            size: 16,
            color: "tertiary.main",
        },
    },
};

styles.printAllQrCodes = linkIconStyleGenerator({
    icon: "QrCode",
    textSize: "15px",
    iconSize: 22,
    additionalTypographyCss: css`
        opacity: 0.8;
        font-weight: ${fontConfig.weight.semiBold};
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
    wrapperCss: css`
        @media (max-width: 1157px) {
            margin-top: 10px;
            margin-right: 30px;
        }
    `,
});

styles.createNewGroup = linkIconStyleGenerator({
    icon: "CreateGroup",
    textSize: "15px",
    iconSize: 14,
    additionalTypographyCss: css`
        opacity: 0.8;
        font-weight: ${fontConfig.weight.semiBold};
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
});

styles.productSelectorStyles = {
    ...styles.productSelectorStyles,
    searchDynamicDropdown: {
        ...styles.productSelectorStyles?.searchDynamicDropdown,
        cssOverrides: {
            ...styles.productSelectorStyles?.searchDynamicDropdown?.cssOverrides,
            formField: css`
                flex-direction: row;
                align-items: center;
                width: 100%;

                label {
                    width: auto;
                    font-weight: ${fontConfig.weight.bold};
                    font-size: ${fontConfig.fontSize.small}px;
                    margin-right: 8px;
                    white-space: nowrap;
                }
                input + span {
                    font-size: ${fontConfig.fontSize.small}px;
                    line-height: ${fontConfig.lineHeight.regular};
                }
                @media (max-width: 650px) {
                    flex-direction: column;
                    align-items: flex-start;
                }
            `,
            list: css`
                top: 32px;
                width: 100%;
                border-top: 0;
            `,
        },
        iconProps: {
            css: css`
                &&&&& {
                    right: 0;
                    top: 5px;
                    padding: 8px;
                }
            `,
        },
    },
    qtyWrapper: {
        css: css`
            ${(styles.productSelectorStyles as any)?.qtyWrapper?.css}
            label + div {
                height: 36px;
            }

            &&&& input {
                height: 28px !important;
            }
        `,
    },
} as any;
